import React, { useContext, useEffect } from 'react';
import { Context } from 'stores/pageLoaderContext';
import Loader from '../Loader';

export const PageLoader = () => {
  const { setLoading } = useContext(Context);

  useEffect(() => {
    setLoading(true);
    return () => {
      setLoading(false);
    };
  }, []);

  return <Loader color={'#825AF7'} />;
};
